import {Component} from '@angular/core';
import {TenantLoaderComponent} from '../../shared/tenant-loader/tenant-loader.component';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [TenantLoaderComponent]
})
export class HeaderComponent {

}
